import {
  ALL_ASSETS_WITH_SITES_LIST_AG,
  ALL_ASSETS_WITH_SITES_LIST_AR,
  ALL_ASSETS_WITH_SITES_LIST_BR,
  ALL_ASSETS_WITH_SITES_LIST_CG,
  ALL_ASSETS_WITH_SITES_LIST_DK,
  ALL_ASSETS_WITH_SITES_LIST_IQ,
  ALL_ASSETS_WITH_SITES_LIST_NG,
  ALL_ASSETS_WITH_SITES_LIST_UK,
  CountryData,
} from 'types/wellGuardian';

export const getAssetList = (countryState: string) => {
  switch (countryState) {
    case CountryData.denmark:
      return ALL_ASSETS_WITH_SITES_LIST_DK;
    case CountryData.nigeria:
      return ALL_ASSETS_WITH_SITES_LIST_NG;
    case CountryData.angola:
      return ALL_ASSETS_WITH_SITES_LIST_AG;
    case CountryData.congo:
      return ALL_ASSETS_WITH_SITES_LIST_CG;
    case CountryData.brazil:
      return ALL_ASSETS_WITH_SITES_LIST_BR;
    case CountryData.iraq:
      return ALL_ASSETS_WITH_SITES_LIST_IQ;
    case CountryData.argentina:
      return ALL_ASSETS_WITH_SITES_LIST_AR;

    default:
      return ALL_ASSETS_WITH_SITES_LIST_UK;
  }
};
